<template>
    <div class="request-result">
        <span class="sp sp1">{{ text }}</span>
        <span class="sp sp2" @click="handleClick">{{ btnText }}</span>
    </div>
</template>

<script>
export default {
    name: 'RequestResult',
    props: {
        btnText: {
            type: String,
            default: '刷新'
        },
        text: {
            type: String,
            default: '很抱歉，请求超时，请稍后再试'
        }
    },
    methods:{
        handleClick() {
            this.$emit('handle')
        }
    }
}
</script>

<style lang="scss" scoped>
.request-result {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;

    .sp {
        &.sp1 {
            color: #615E83;
            text-align: center;
            font-family: HYQiHei;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            margin: 0 0 20px 0;
        }

        &.sp2 {
            border-radius: 12px;
            border: 1px solid rgba(0, 0, 0, 0.02);
            background: rgba(74, 58, 255, 0.10);
            padding: 5px 24px;
            color: rgba(74, 58, 255, 0.70);
            font-feature-settings: 'ss01' on, 'cv01' on, 'cv11' on;
            font-family: HYQiHei;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 21px;
            cursor: pointer;
        }
    }
}
</style>